import { iterable, mix, patch } from "@chorda/core";
export const RowLayout = (elements) => {
    return mix({
        css: 'rows',
        defaultItem: {
            css: 'row',
            reactions: {
                rows: (v) => patch({ components: { content: v } })
            }
        },
        reactions: {
            rows: (v) => patch({ items: v })
        }
    }, {
        injections: {
            rows: () => iterable(elements, 'rows')
        }
    });
};
